// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9c097808","732":"75656374","977":"b8763b32"}[chunkId] + ".chunk.js";
};